// 찾아오시는 길
import React, { useEffect } from "react";
import { MenuContainer } from "../../components/menuContainer/MenuContainer";
import "../../styles/map.css";
import { motion } from "framer-motion";

const Kakao_Key = "84eebd1326295b35c3c54841ac522c3e";

const x = 34.90365514308963;
const y = 127.64791327568197;

export const Map = () => {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src*="dapi.kakao.com/v2/maps/sdk.js"]'
    );

    const loadMap = () => {
      if (window.kakao && window.kakao.maps) {
        window.kakao.maps.load(() => {
          var staticMapContainer = document.getElementById("static-map");
          var containerWidth = staticMapContainer.offsetWidth;
          var containerHeight = staticMapContainer.offsetHeight;

          const marker = {
            position: new window.kakao.maps.LatLng(x, y),
          };

          var staticMapOption = {
            center: new window.kakao.maps.LatLng(x, y),
            level: 4,
            marker: marker,
            width: containerWidth,
            height: containerHeight,
          };

          new window.kakao.maps.StaticMap(staticMapContainer, staticMapOption);
        });
      }
    };

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${Kakao_Key}&autoload=false`;
      script.async = true;
      script.onload = loadMap;
      document.head.appendChild(script);
    } else {
      loadMap(); // 스크립트가 이미 있는 경우에도 지도 로드
    }
  }, []);

  return (
    <MenuContainer title="회사소개" menu="찾아오시는 길" pointRadius="50%">
      <motion.div
        layout="size"
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: "easeInOut",
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        <div className="container d-flex justify-content-center flex-column align-items-center">
          <div className="map-div">
            <div id="static-map"></div>
          </div>
          <p className="map-description">클릭 시 지도로 이동합니다.</p>
          <div className="name-card-div">
            <table
              className="table table-borderless m-0"
              style={{ backgroundColor: "#e2f3fa" }}
            >
              <tbody>
                <tr>
                  <th
                    className="align-top text-color fx-bold"
                    style={{ background: "#e2f3fa" }}
                  >
                    주소
                  </th>
                  <td
                    className="align-middle text-color ps-4"
                    style={{ background: "#e2f3fa", fontWeight: "normal" }}
                  >
                    <div>전남 광양시 항만2로 114 서진로지텍</div>
                  </td>
                </tr>
                <tr>
                  <th
                    className="align-top text-color no-separator ps-4"
                    style={{ background: "#e2f3fa" }}
                  ></th>
                  <td
                    className="align-middle text-color pt-0 add-data ps-4"
                    style={{ background: "#e2f3fa" }}
                  >
                    지번 | 황길동 1413
                    <br />
                    우편번호 | 57771
                  </td>
                </tr>
                <tr>
                  <th
                    className="align-middle text-color"
                    style={{ background: "#e2f3fa" }}
                  >
                    이메일
                  </th>
                  <td
                    className="align-middle text-color ps-4"
                    style={{ background: "#e2f3fa", fontWeight: "normal" }}
                  >
                    seojinlgt@seojinlgt.co.kr
                  </td>
                </tr>
                <tr>
                  <th
                    className="align-middle text-color"
                    style={{ background: "#e2f3fa" }}
                  >
                    대표전화
                  </th>
                  <td
                    className="align-middle text-color ps-4"
                    style={{ background: "#e2f3fa", fontWeight: "normal" }}
                  >
                    061-795-0096
                  </td>
                </tr>
                <tr>
                  <th
                    className="align-middle text-color"
                    style={{ background: "#e2f3fa" }}
                  >
                    팩스번호
                  </th>
                  <td
                    className="align-middle text-color ps-4"
                    style={{ background: "#e2f3fa", fontWeight: "normal" }}
                  >
                    070-7610-9220
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </motion.div>
    </MenuContainer>
  );
};
